<template>
  <AppCoupon ad_mold="coupon_for_homepage" />
</template>

<script>
import AppCoupon from '@/views/ad/components/app-coupon/app-coupon'
export default {
  name: 'AppHomeRecommendCoupon',
  components: {
    AppCoupon,
  },
}
</script>
